<template>
  <div style="margin-top:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Report Converter</span><br/>
      <span style="font-style: italic; font-size: 18px">convert files exported from other systems (email support to add a new file conversion)</span>
    </div>

    <div style="font-size: 22px; font-weight: bold; margin:50px">
      Convert CM Revenue By Vehicle Detailed (CSV) --> Revenue By Date (CSV)
      <br/>
      <b-form-file style="width:1000px; margin: 20px"
                   v-model="file"
                   :state="Boolean(file)"
                   placeholder="select a file to convert"
                   drop-placeholder="Drop file here..."></b-form-file>
      <span>
            <br/><b-btn size="lg" v-if="file" v-on:click="convertFile()">Convert CSV</b-btn>
      </span>

    </div>

  </div>
</template>

<script>

    import {mapState} from "vuex";
    import axios from "axios";

    export default {
      name: 'report_converter',
      components: {
      },

      data() {
        return {
          file: null,
        }
      },

      async created() {
      },
      methods: {
        async convertFile() {
          this.$emit('showAlert', "processing file", 'info')

          let formData = new FormData();
          formData.append('file', this.file);
          axios.post( process.env.VUE_APP_API_URL + 'bookings/report/convert/' + this.user.tenant,
              formData,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                  'Content-Type': 'multipart/form-data'
                }
              })
              .then((response) => {
                axios.defaults.headers.common.Accept = 'application/json'
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute(
                    'download',
                    `rev-by-date.csv`
                )
                document.body.appendChild(link)
                link.click()
                this.$emit('showAlert', 'file processing complete', 'success', 5000)
              }).catch(e => {
                axios.defaults.headers.common.Accept = 'application/json'
                this.$emit('showAlert', 'error converting file, make sure it is a valid CSV', 'danger')
              })
        }
      },
      computed:{
        ...mapState({
          user: state => state.profile.user
        }),
      },
    }
</script>

<style>
</style>

